export const moduleCode = {
  TRANGCHU: "vanhanh_trangchu",
  DANHMUC: "danh_muc",
  QUANTRIHETHONG: "quan_tri_he_thong",
  THONGTINSANXUAT: "thong_tin_san_xuat",
  BAOCAOTHONGKE: "bao_cao_thong_ke",
  BanDo: "ban_do",
  SanPham: "san_pham",
  ThongTinDoanhNghiep: "thong_tin_doanh_nghiep",
  LoHang: "lo_hang",
  LichSuSanXuat: "lich_su_san_xuat",
  ThongTinLichSuSanXuat: "thong_tin_lich_su_san_xuat",
  ThongTinLichSuCheBien: "thong_tin_lich_su_che_bien",
  ThongTinLichSuPhanPhoi: "thong_tin_lich_su_phan_phoi",
  VungTrong: "vung_trong",
  NHATKYHETHONG: "nhat_ky_he_thong"
};

export const maChucNang = {
  //Trang chủ
  TC: "vanhanh_trangchu",
  DANHMUC: "danh_muc",

  // Quản trị hệ thống
  QUANTRIHETHONG_QUANLYNGUOIDUNG: "quan_tri_he_thong_Quan_ly_nguoi_dung",
  QUANTRIHETHONG_CAUHINHHIENTHISANPHAM:
    "quan_tri_he_thong_Cau_hinh_hien_thi_san_pham",
  QUANTRIHETHONG_QUANLYSLIDE: "quan_tri_he_thong_Quan_ly_slide",
  QUANTRIHETHONG_QUANLYTINTUC: "quan_tri_he_thong_Quan_ly_tin_tuc",
  QUANTRIHETHONG_PHANQUYENCHUCNANG: "quan_tri_he_thong_Phan_quyen_chuc_nang",
  QUANTRIHETHONG_QUANLYNHOMNGUOIDUNG: "quan_tri_he_thong_Quan_ly_nhom_nguoi_dung",
  QUANTRIHETHONG_QUANLYNHOMCHUCNANG: "quan_tri_he_thong_Quan_ly_nhom_chuc_nang",
  QUANTRIHETHONG_QUANLYCHUCNANG: "quan_tri_he_thong_Quan_ly_chuc_nang",

  // Thông tin sản xuất
  THONGTINSANXUAT_COSOPHANPHOI: "thong_tin_san_xuat_Co_so_phan_phoi",
  THONGTINSANXUAT_COSOSANXUAT: "thong_tin_san_xuat_Co_so_san_xuat",
  THONGTINSANXUAT_COSOCHEBIEN: "thong_tin_san_xuat_Co_so_che_bien",

  // Báo cáo thống kê
  BAOCAOTHONGKE_DULIEUTHONGKE: "bao_cao_thong_ke_Du_lieu_thong_ke",
  BAOCAOTHONGKE_DULIEUKHIHAU: "bao_cao_thong_ke_Du_lieu_khi_hau",
  BAOCAOTHONGKE_BAOCAOCHUYENDE: "bao_cao_thong_ke_Bao_cao_chuyen_de",

  //Sản phẩm
  SANPHAM: "san_pham",

  THONGTINDOANHNGHIEP: "thong_tin_doanh_nghiep",
  LOHANG: "lo_hang",
  LICHSUSANXUAT: "lich_su_san_xuat",
  THONGTINLICHSUSANXUAT: "thong_tin_lich_su_san_xuat",
  THONGTINLICHSUCHEBIEN: "thong_tin_lich_su_che_bien",
  THONGTINLICHSUPHANPHOI: "thong_tin_lich_su_phan_phoi",
  VUNGTRONG: "vung_trong",

  //Bản đồ
  BANDO: "ban_do",
  NHATKYHETHONG: "nhat_ky_he_thong"
};

export const Constant = {
  CAP_TRIEN_KHAI: Number(process.env.REACT_APP_CAP_TRIEN_KHAI),
  TITLE_TO_CHUC: process.env.REACT_APP_TITLE_TC,
  TITLE_PHAN_MEM: process.env.REACT_APP_TITLE_PM,
  MA_DVHC: process.env.REACT_APP_MA_DVHC,
  MA_TINH: process.env.REACT_APP_MA_TINH,
  TEN_DVHC: process.env.REACT_APP_TEN_DVHC,
  SCOPE_VIEWMAP_PROVINCE: process.env.REACT_APP_SCOPE_VIEWMAP,
  MUI_CHIEU: [
    { id: 3, ten: "Múi chiếu 3 độ" },
    { id: 6, ten: "Múi chiếu 6 độ" }
  ],
  KINH_TUYEN_TRUC_LIST: [
    { maMuc: "105_00", tenMuc: "Trung ương" },
    { maMuc: "108_30", tenMuc: "Địa phương - Phú Yên (108°30')" }
  ],
  KINH_TUYEN_TRUC: {
    maMuc: "108_30",
    tenMuc: "Địa phương - Phú Yên (108°30')"
  },
  LOAIDIEMTRAMQTMT: [
    { id: "1", ten: "Điểm quan trắc định kỳ xung quanh" },
    { id: "2", ten: "Trạm quan trắc tự động xung quanh" },
    { id: "3", ten: "Điểm quan trắc định kỳ tại cơ sở" },
    { id: "4", ten: "Trạm quan trắc tự động tại cơ sở" }
  ],
  CAP_TQ: {
    TRUNGUONG: 1,
    DIAPHUONG: 2
  },
  LOAI_KINH_TUYEN_TRUC: [
    { maMuc: 1, tenMuc: "Trung ương" },
    { maMuc: 2, tenMuc: "Địa phương (Lạng Sơn 107°15')" }
  ],
  CAP_DVHC: [
    { id: 1, ten: "Cấp Tỉnh" },
    { id: 2, ten: "Cấp Huyện" },
    { id: 3, ten: "Cấp Xã" }
  ],
  ToaDo_Diem_Vung: [
    { id: 1, ten: "Tọa độ điểm" },
    { id: 2, ten: "Tọa độ vùng" }
  ],
  Ten_DTM: {
    DTM_DGTDMT: "01",
    DTM_KHBVMT: "02",
    DTM_PABVMT: "03",
    DTM_DABVMT: "04",
    DTM_CKBVMT: "05",
    DTM_DKDTCMT: "06"
  },
  LoaiVanBanList: [
    { maMuc: "01", tenMuc: "Đánh giá tác động môi trường" },
    { maMuc: "02", tenMuc: "Kế hoạch bảo vệ môi trường" },
    { maMuc: "03", tenMuc: "Phương án bảo vệ môi trường" },
    { maMuc: "04", tenMuc: "Đề án bảo vệ môi trường" },
    { maMuc: "05", tenMuc: "Cam kết bảo vệ môi trường" },
    { maMuc: "06", tenMuc: "Đăng ký đạt tiêu chuẩn môi trường" }
  ],
  LoaiGiayPhepMoiTruongList: [
    {
      maMuc: "01",
      tenMuc: "Giấy xác nhận hoàn thành công  trình bảo vệ môi trường"
    },
    { maMuc: "02", tenMuc: "Giấy phép xử lý chất thải nguy  hại" },
    { maMuc: "03", tenMuc: "Sổ đăng ký chủ nguồn thải chất  thải nguy hại" },
    { maMuc: "04", tenMuc: "Giấy phép xả khí thải" },
    { maMuc: "05", tenMuc: "Giấy phép xả nước thải vào  nguồn nước" },
    { maMuc: "06", tenMuc: "Giấy phép xả nước thải vào công  trình thủy lợi" },
    {
      maMuc: "07",
      tenMuc:
        "Giấy xác nhận đủ điều kiện về  bảo vệ môi trường trong nhập  khẩu phế liệu làm nguyên liệu  sản xuất"
    },
    { maMuc: "08", tenMuc: "Giấy phép khai thác, sử dụng  nước dưới đất" },
    { maMuc: "09", tenMuc: "Giấy phép môi trường" },
    { maMuc: "10", tenMuc: "Đăng ký môi trường" },
    { maMuc: "11", tenMuc: "Giấy phép khai thác khoáng sản" },
    { maMuc: "12", tenMuc: "Giấy phép khai thác và sử dụng  nước mặt" }
  ],
  KinhTuyenTruc: [
    { maMuc: "105_00", tenMuc: "Trung ương (105°)" },
    { maMuc: "107_15", tenMuc: "Địa phương (Lạng Sơn 107°15')" }
  ],
  HE_SO_KQ: [
    { id: 0, ten: "0.6", value: 0.6 },
    { id: 1, ten: "0.8", value: 0.8 },
    { id: 2, ten: "0.9", value: 0.9 },
    { id: 3, ten: "1", value: 1 },
    { id: 4, ten: "1.1", value: 1.1 },
    { id: 5, ten: "1.2", value: 1.2 },
    { id: 6, ten: "1.3", value: 1.3 }
  ],

  HE_SO_KF: [
    { id: 0, ten: "0.9", value: 0.9 },
    { id: 1, ten: "1.0", value: 1.0 },
    { id: 2, ten: "1.1", value: 1.1 },
    { id: 3, ten: "1.2", value: 1.2 },
    { id: 4, ten: "1.3", value: 1.3 }
  ],
  TRANGTHAIHOATDONG: [
    { id: 0, ten: "Đang hoạt động", value: "danghoatdong" },
    { id: 1, ten: "Ngừng hoạt động", value: "ngunghoatdong" },
    { id: 2, ten: "Chưa hoạt động", value: "chuahoatdong" }
  ],
  THANH_PHAN_MOI_TRUONG: [
    { id: 1, ten: "Nước mặt" },
    { id: 2, ten: "Nước dưới đất" },
    { id: 3, ten: "Nước xả thải" },
    { id: 5, ten: "Không khí ngoài trời, tiếng ồn, độ rung" },
    { id: 9, ten: "Nước biển" },
    { id: 10, ten: "Nước mưa" },
    { id: 11, ten: "Khí thải" },
    { id: 12, ten: "Đất" },
    { id: 13, ten: "Trầm tích" },
    { id: 14, ten: "Chất thải nguy hại" }
  ],
  DATA_SELECT: [
    { name: "=", value: "=" },
    { name: ">", value: ">" },
    { name: "<", value: "<" },
    { name: "<=", value: "<=" },
    { name: ">=", value: ">=" }
  ],

  DATA_KETQUADANHGIA: [
    { id: 1, name: "Vượt ngưỡng", value: "vuotnguong" },
    { id: 2, name: "Bình thường", value: "binhthuong" }
  ],
  METHOD: [
    { id: 0, ten: "GET", value: "GET" },
    { id: 1, ten: "POST", value: "POST" },
    { id: 2, ten: "PUT", value: "PUT" },
    { id: 3, ten: "DELETE", value: "DELETE" }
  ],
  LoaiTaiLieuBDKH: [
    { maMuc: "01", tenMuc: "Văn bản quy định của nhà nước về BĐKH" },
    { maMuc: "02", tenMuc: "Văn bản triển khai tại tỉnh" },
    { maMuc: "03", tenMuc: "Nhiệm vụ triển khai kế hoạch ứng phó BHKH" }
  ],
  LoaiTaiLieuKTTV: [
    { maMuc: "01", tenMuc: "Văn bản quy định" },
    { maMuc: "02", tenMuc: "Văn bản triển khai" },
    { maMuc: "03", tenMuc: "Công tác quản lý khí tượng thủy văn" }
  ],
  TINHTHANH: {
    cap: 1,
    hoatDong: 1,
    id: "1054",
    maDVHC_Cu: null,
    maHuyen: "0",
    maTinh: "54",
    maXa: "0",
    ten: "tỉnh phú yên",
    tenDVHC: "Tỉnh Phú Yên"
  },
  CAP:
    [
      {
          id: 2,
          ten: "Admin"
      },
      {
          id: 3,
          ten: "Lãnh đạo, chuyên viên nghiệp vụ, phòng ban thuộc bộ"
      },
      {
          id: 4,
          ten: "Tổ chức/Doanh nghiệp"
      },
      {
          id: 5,
          ten: "Lãnh đạo, chuyên viên nghiệp vụ, phòng ban thuộc sở"
      }
    ],
  TrangThaiSanXuat: [
    { id: 1, ten: "Đang sản xuất" },
    { id: 2, ten: "Đang bán" },
    { id: 3, ten: "Đã bán" }
  ],
  TrangThaiThongTin: [
    { id: 1, ten: "Đang chế biến" },
    { id: 2, ten: "Đã phân phối" },
  ],
  TrangThaiMua: [
    { id: 1, ten: "Mới mua" },
    { id: 2, ten: "Đã chế biến" },
  ],
  TrangThaiMuaPhanPhoi: [
    { id: 1, ten: "Mới mua" },
    { id: 2, ten: "Đã phân phối" },
  ],
  PositionInit: [13.201609, 109.152846]
};
